module.exports = __webpack_public_path__ + "static/media/MonthlyMagazine.1906fe4e.jpg";